export const transition = { 
    duration: .25, 
    ease: [.56, .03, .12, 1.04]
};

export const variants = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
    },
    disabled: {
        opacity: .6
    },
    enabled: {
        opacity: 1
    },
    smallWrap: width => ({
        width: width > 768 ? '3rem' : '2rem',
        minWidth: width > 768 ? '3rem' : '2rem'
    }),
    largeWrap: width => ({
        width: width > 768 ? '6rem' : '4rem',
        minWidth: width > 768 ? '6rem' : '4rem'
    })
}